import type { Ref } from "react";

interface CardinalCompassProps {
  /** Inner rose. The 3D view rotates this so N keeps pointing north. */
  roseRef?: Ref<HTMLDivElement>;
  label: string;
}

/**
 * Cardinal disc for the quote map views. The outer ring stays put.
 * Leave the rose unrotated for a north-up satellite photo.
 */
export default function CardinalCompass({ roseRef, label }: CardinalCompassProps) {
  return (
    <div
      role="img"
      aria-label={label}
      className="pointer-events-none absolute left-3 top-3 z-10 flex h-14 w-14 items-center justify-center overflow-hidden rounded-full border border-white/10 bg-black/60 shadow-sm backdrop-blur-sm"
    >
      <div ref={roseRef} className="h-12 w-12">
        <svg viewBox="0 0 48 48" className="h-full w-full" aria-hidden="true">
          <polygon points="24,12 21,22 27,22" fill="#D4FF00" />
          <polygon points="24,36 21,26 27,26" fill="white" fillOpacity="0.35" />
          <circle cx="24" cy="24" r="1.5" fill="white" />
          <text x="24" y="10" textAnchor="middle" fill="#D4FF00" fontSize="7" fontWeight="700" fontFamily="inherit">
            N
          </text>
          <text x="42" y="26" textAnchor="middle" fill="white" fillOpacity="0.7" fontSize="6.5" fontWeight="600" fontFamily="inherit">
            E
          </text>
          <text x="24" y="45" textAnchor="middle" fill="white" fillOpacity="0.7" fontSize="6.5" fontWeight="600" fontFamily="inherit">
            S
          </text>
          <text x="6" y="26" textAnchor="middle" fill="white" fillOpacity="0.7" fontSize="6.5" fontWeight="600" fontFamily="inherit">
            W
          </text>
        </svg>
      </div>
    </div>
  );
}
